import { PlaylistAnalyticsResponseDTO } from '@core/api/dtos/response/playlist/playlist'
import { PlaylistAnalytics } from '@core/api/entities/playlist/playlist'

export class PlaylistAnalyticsMapper {
	static toEntity(data: PlaylistAnalyticsResponseDTO): PlaylistAnalytics {
		return new PlaylistAnalytics({
			size: data.size,
			count: data.count,
			length: data.length,
			artists: data.artists,
		})
	}
}
